import { FC } from 'react'
import clsx from 'clsx'
import styles from './BetTabBar.module.css'

interface TabItem {
  label: string
  value: string
}

interface BetTabBarProps {
  tabs: TabItem[]
  activeTab: string
  onChange: (value: string) => void
}

export const BetTabBar: FC<BetTabBarProps> = ({
  tabs,
  activeTab,
  onChange,
}) => {
  return (
    <div
      className={`flex w-full bg-[var(--tab-bg)] border border-[var(--tab-border)] overflow-hidden rounded-xl ${styles.betTabBar}`}
    >
      {tabs.map(({ label, value }) => {
        const isActive = activeTab === value
        return (
          <button
            key={value}
            onClick={() => onChange(value)}
            className={clsx(
              'flex-1 py-4 sm:py-6 px-6 transition-all duration-200 cursor-pointer',
              isActive
                ? 'active-gradient text-[var(--tab-text-active)]'
                : 'text-[var(--tab-text)] hover:bg-[var(--tab-hover-bg)] hover:text-[var(--tab-hover-text)] hover:border-[var(--tab-hover-border)]',
            )}
          >
            <h5
              className={clsx(
                'm-0 text-sm',
                isActive ? 'font-semibold' : 'font-medium',
              )}
            >
              {label}
            </h5>
          </button>
        )
      })}
    </div>
  )
}
